import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "page-box-title title1" }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { class: "page-tab" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "history-box" }
const _hoisted_8 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "history-box-item-top" }
const _hoisted_11 = { class: "title1" }
const _hoisted_12 = { class: "history-box-item-tag" }
const _hoisted_13 = { class: "history-box-item-inner" }
const _hoisted_14 = { class: "history-box-item-bottom" }
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = { class: "history-box-bottom-icon" }
const _hoisted_17 = {
  class: "history-box-bottom-icon",
  style: {"margin-left":"8px"}
}
const _hoisted_18 = { class: "history-box-bottom-icon" }
const _hoisted_19 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_20 = { class: "page-inner page-right" }
const _hoisted_21 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_22 = { class: "page-box-title2 title1" }
const _hoisted_23 = { class: "page-inner-box" }
const _hoisted_24 = { class: "page-inner page-left" }
const _hoisted_25 = { style: {"margin":"20px 0"} }
const _hoisted_26 = { class: "page-inner page-right" }
const _hoisted_27 = { class: "page-box-title2 title1" }
const _hoisted_28 = {
  key: 0,
  class: "page-inner-box"
}
const _hoisted_29 = {
  key: 1,
  class: "page-inner-box empty"
}

import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { compMaterialStreamingV1, saveSreamResult, getMaterial, materialDel, materialAdd, getMaterialDetail } from "@/api/composition.js"
import { formatterEvent } from "@/utils/common.js"
import { ElMessage, ElMessageBox } from "element-plus";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { Search } from '@element-plus/icons-vue'
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'sourceMaterialMy',
  setup(__props) {

const store = useStore();
let { toClipboard } = clipBoard()

// 列表
const isEdit = ref(false)
const tabActive = ref('all')
const keyword = ref('')
const tableList = ref([])
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const detailInfo = ref({})
const detailIndex = ref(0)
const tabList = [
    {
        label: '全部',
        value: 'all'
    },
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]


function tabChange(item) {
    if (item.value == tabActive.value) return
    tabActive.value = item.value
    handleCurrentChange(1)
}

function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: tabActive.value == 'all' ? '' : tabActive.value,
        title: keyword.value,
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getMaterial(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        if (tableList.value.length) {
            itemClick(tableList.value[0], 0)
        } else {
            detailInfo.value = {}
            detailIndex.value = 0
        }
    })
}

function typeFormat(val) {
    return formatterEvent(tabList, val)
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}

function delEvent() {
    const arr = tableList.value.filter(item => {
        return item.checked
    })
    if (!arr.length) {
        return ElMessage.warning('请选择记录')
    }
    ElMessageBox.confirm(
        `确认删除已选记录？`,
        '删除提醒'
    ).then(() => {
        let idList = arr.map(item => {
            return item.id
        })
        materialDel({
            idList
        }).then(res => {
            ElMessage.success('删除成功！')
            handleCurrentChange(1)
        })
    })
}

function itemClick(item, index) {
    detailIndex.value = index
    getMaterialDetail({ type: 1, id: item.id }).then(res => {
        detailInfo.value = res.data;
    })
}

onMounted(() => {
    getList()
})

// 列表




// 编辑
const pickerColumns = [
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]

const formData = ref({
    content: '',
    title: '',
    type: ''
})

let resultInfo = ref({})

function submitEvent() {
    const { content = '',
        title = '',
        type = '' } = formData.value;
    if (!title) {
        return ElMessage.warning('请填写素材标题');
    }
    if (!content) {
        return ElMessage.warning('请填写素材内容');
    }
    if (!title) {
        return ElMessage.warning('请选择素材类型');
    }
    materialAdd(formData.value).then(res => {
        if (res.data) {
            ElMessage.success('保存成功！')
            resultInfo.value = res.data;
            handleCurrentChange(1)
        }
    })
}

async function copyEvent() {
    try {
        let text = ''
        let obj = isEdit.value ? resultInfo.value : detailInfo.value
        if (Object.keys(obj).length) {
            text = obj.content
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

function backEvent() {
    isEdit.value = false
    resultInfo.value = {}
    formData.value = {
        content: '',
        title: '',
        type: ''
    }
}

// 编辑

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_Clock = _resolveComponent("Clock")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, " 我的素材库 ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: keyword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            placeholder: "请输入关键词",
            "suffix-icon": _unref(Search),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (handleCurrentChange(1)))
          }, null, 8, ["modelValue", "suffix-icon"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (item) => {
          return _createElementVNode("div", {
            key: item.value,
            class: _normalizeClass(['page-tab-item',tabActive.value==item.value?'page-tab-item-active':'']),
            onClick: ($event: any) => (tabChange(item))
          }, _toDisplayString(item.label), 11, _hoisted_6)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!tableList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[9] || (_cache[9] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1),
              _createElementVNode("div", null, "暂无数据", -1)
            ])))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tableList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['history-box-item',detailIndex.value==index?'active':'']),
                key: item.artiCorrectingId,
                onClick: ($event: any) => (itemClick(item,index))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: item.checked,
                      "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                      style: {"margin-right":"5px"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass([`classType${item.type}`])
                    }, _toDisplayString(typeFormat(item.type)), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.content), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Menu)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "来源：" + _toDisplayString(item.origin=='01'?'开悟作文':'其他书籍'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_StarFilled)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "收藏：" + _toDisplayString(item.collectNum), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_icon, { size: "14" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Clock)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, "发布：" + _toDisplayString(item.createTime), 1)
                  ])
                ])
              ], 10, _hoisted_9))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        (pageShow.value)
          ? (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 0,
              locale: _unref(zhCn)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_pagination, {
                  "current-page": pageInfo.value.current,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageInfo.value.current) = $event)),
                  "page-size": pageInfo.value.size,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageInfo.value.size) = $event)),
                  total: pageInfo.value.total,
                  "page-sizes": [10, 20, 30, 50],
                  layout: "total, sizes,jumper",
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ]),
              _: 1
            }, 8, ["locale"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_row, {
        gutter: 20,
        style: {"margin-top":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "page-box-btn danger",
                onClick: delEvent
              }, "删除")
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 16 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "page-box-btn warning",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (isEdit.value=true))
              }, "自建素材")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !isEdit.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_20, [
      (!Object.keys(detailInfo.value).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[10] || (_cache[10] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "暂无数据", -1)
          ])))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(detailInfo.value.title) + " ", 1),
              _withDirectives(_createVNode(_component_el_button, {
                color: "#ef8b25",
                class: "footer-btn1",
                onClick: copyEvent,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("复制素材")
                ])),
                _: 1,
                __: [11]
              }, 512), [
                [_vShow, Object.keys(detailInfo.value).length]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, _toDisplayString(detailInfo.value.content), 1)
          ], 64))
    ], 512), [
      [_vShow, !isEdit.value]
    ]),
    (isEdit.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_24, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-box-title title1" }, "个人素材", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_el_row, {
                gutter: 10,
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        maxlength: "50",
                        modelValue: formData.value.title,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.title) = $event)),
                        type: "textarea",
                        placeholder: "请填写素材标题（必填项）"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                gutter: 10,
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        maxlength: "5000",
                        modelValue: formData.value.content,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.content) = $event)),
                        type: "textarea",
                        rows: 6,
                        placeholder: "输入要生成的素材的文本内容"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "correct-tip" }, [
                _createElementVNode("span", { class: "activeColor" }, "*提示："),
                _createElementVNode("span", null, "所有字段都为必填，请认真填写和选择")
              ], -1)),
              _createVNode(_component_el_row, {
                gutter: 10,
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.type,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.type) = $event)),
                        placeholder: "请选择类型"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pickerColumns, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: item.label
                            }, null, 8, ["value", "label"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        style: {"width":"100%"},
                        color: "#ef8b25",
                        class: "footer-btn1",
                        onClick: submitEvent
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("确认保存")
                        ])),
                        _: 1,
                        __: [13]
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        style: {"width":"100%"},
                        type: "info",
                        class: "footer-btn1",
                        onClick: backEvent
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("返回")
                        ])),
                        _: 1,
                        __: [14]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[17] || (_cache[17] = _createTextVNode(" 个人素材生成结果 ")),
              _withDirectives(_createVNode(_component_el_button, {
                color: "#ef8b25",
                class: "footer-btn1",
                onClick: copyEvent,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("复制素材")
                ])),
                _: 1,
                __: [16]
              }, 512), [
                [_vShow, Object.keys(_unref(resultInfo)).length]
              ])
            ]),
            (Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(resultInfo).content), 1))
              : _createCommentVNode("", true),
            (!Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[18] || (_cache[18] = [
                  _createElementVNode("img", { src: _imports_0 }, null, -1),
                  _createElementVNode("div", null, "结果将在此处展示！", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})